import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HomePageRoutingModule } from './home-page-routing.module';
import { HomePageComponent } from './home-page.component';
import { SharedModule } from '../shared/shared.module';
import { SkeletonLoaderComponent } from '../shared/components/skeleton-loader/skeleton-loader.component';
import { SkeletonLoaderModule } from '../shared/components/skeleton-loader/skeleton-loader.module';

@NgModule({
  declarations: [
    HomePageComponent  ],
  imports: [
    CommonModule,
    HomePageRoutingModule,
    RouterModule,
    SharedModule,
    SkeletonLoaderModule
  ],

})
export class HomePageModule { }
